import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Single labeled <Input> row — shared between the two RegisterDialog steps.
 * Kept tiny on purpose; do not extend with more behaviour. Add new fields by
 * composing this component, not by passing more flags.
 */
export default function FieldRow({
  id, label, testId, value, onChange,
  type = "text", inputMode, required, minLength, maxLength, placeholder,
}) {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={id} className="text-[13px] font-semibold tracking-wide uppercase" style={{ color: "var(--np-primary)" }}>
        {label}
      </Label>
      <Input
        id={id} data-testid={testId}
        type={type} inputMode={inputMode}
        required={required} minLength={minLength} maxLength={maxLength}
        value={value} onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="h-11 rounded-lg border-[#dbe3ec] focus-visible:ring-[var(--np-secondary)]"
      />
    </div>
  );
}
